import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'

import { ConsentsByForm } from './components'

import { DashboardCounterCard } from 'components'

import constants from 'constants/index'

const DashboardConsent = ({ consentStats }) => {
  const { consent: consentIds } = constants.myLgpd.GRAPH_IDS

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Consentimentos
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <DashboardCounterCard
            label="Quantidade Total de Formulários"
            value={consentStats?.totalConsentForms}
            sizes={{ xs: 12, md: 3 }}
          />
          <Grid item xs={12} md={9}>
            <ConsentsByForm
              consentForms={consentStats?.consentForms}
              id={consentIds.consentsByForm}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

DashboardConsent.propTypes = {
  consentStats: PropTypes.object.isRequired,
}

export default DashboardConsent
